// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolJoinRequestCancelBody = {
  targetPoolId: string;
};

export type typePoolJoinRequestCancelOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { poolId: string; hasCanceled: boolean };
};

export type typePoolJoinRequestCancelOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolJoinRequestCancelOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolJoinRequestCancelOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolJoinRequestCancelBody = {
  type: "object",
  properties: {
    targetPoolId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["targetPoolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolJoinRequestCancel(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolJoinRequestCancelBody);
  }

  return async function postPoolJoinRequestCancel(
    payload: typePoolJoinRequestCancelBody,
  ): Promise<
    typePoolJoinRequestCancelOutput200 | typePoolJoinRequestCancelOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolJoinRequestCancel" failed before calling the network. #9f447ea76bbe`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#9f447ea76bbe" },
        },
        data: null,
      } as typePoolJoinRequestCancelOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/join-request-cancel`,
      httpMethod: "POST",
      options,
    })) as
      typePoolJoinRequestCancelOutput200 | typePoolJoinRequestCancelOutput400;
  };
}
